module.exports = __webpack_public_path__ + "media/images/star-solid-3f5eb997d90860946b7a4f3e38088eb4.svg";